import {
	lazy,
} from 'react'

export const ClubsPageAsync = lazy(async() => {
	return import('./clubs.page')
})
